// 对 Social New/Engaged Lead打标,当Lead访问Social Post包含的短链，标记Tag为Social Studio。
import axios from 'axios';
import util from '@/common/util';
export const loginOrRegister = {
    login: 1,
    register: 0
};
export function setLeadTag(tagType, leadUserId, teamId) {
    const utm_source = util.getCookie('utm_source'),
        cpclid = util.getCookie('cpclid');
    if (!utm_source || !cpclid) return;
    axios.post('/social-media/statistics/lead/leadPickTag', {
        leadUserId: leadUserId,
        teamId: teamId,
        cpclid: cpclid,
        tagType: tagType,
        source: utm_source
    });
}
